import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';
import { FootprintApiManager_FrontendFlowService } from './FootprintApiManager.frontend.flow.index';
import { FootprintEdi_FrontendFlowService } from './FootprintEdi.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    public FootprintApiManager: FootprintApiManager_FrontendFlowService,
    public FootprintEdi: FootprintEdi_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
